import axios from './http'

export default {
    
    getAllReward(){
        return axios.get('/reward/list')
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    getAllRewardOwner(){
        return axios.get('/reward/get-owner')
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    getClaimData(){
        return axios.get('/reward/claim')
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    getCampaignData(){
        return axios.get('/campaign')
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    createReward(data){
  
        return axios.post('/reward/create', data)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    updateReward(data){
        return axios.put('/reward', data)
            .then(function (response) {
                return Promise.resolve(response.data)
            })
            .catch(function (error) {
                return Promise.reject(error.response.data.error)
            });
    },
    searchReward(keyword){
        return axios.get('/reward/search',{
            params: {
                key: keyword
            }
        })
        .then(function (response) {
            return Promise.resolve(response)
        })
        .catch(function (error) {
            return Promise.reject(error)
        });
    },
    getOneReward(id){
        return axios.get('/reward/'+id)
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            });
    },
    deleteReward(id){
        return axios.delete('/reward/',
            {
                data: {
                    "id": id,
                }
            })
            .then(function (response) {
                return Promise.resolve(response)
            })
            .catch(function (error) {
                return Promise.reject(error)
            }); 
    }
}